import {useMemo} from 'react';

import {matchPath, useLocation} from 'react-router-dom';

import ROUTES from 'routes';


export const useAppParams = () => {
    const location = useLocation();

    return useMemo(
        () =>
            Object.values(ROUTES).reduce<Record<string, string>>((acc, item) => {
                const match = matchPath(location.pathname, {
                    path: item.path,
                    exact: true,
                });

                return {
                    ...acc,
                    ...match?.params,
                };
            }, {}),
        [location.pathname],
    );
};
